import styled from '@emotion/styled'
import { CSSProperties, ReactNode } from 'react'
import { WHITE } from '../../constant/colors'

const ContainerStyle = styled.div`
  width: 100%;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
`

const ScrollStyle = styled.div<{
  backgroundColor: string
}>`
  display: flex;
  background: ${({ backgroundColor }) => backgroundColor};
`

interface SliderProps {
  backgroundColor?: string
  children?: ReactNode
  style?: CSSProperties
}

const Slider = (props: SliderProps) => {
  const { children, backgroundColor = WHITE, style } = props

  return (
    <ContainerStyle style={style}>
      <ScrollStyle backgroundColor={backgroundColor}>{children}</ScrollStyle>
    </ContainerStyle>
  )
}

export default Slider
